'use client';

import React from 'react';
import { Box, SwipeableDrawer, Typography } from '@mui/material';

export interface BottomFilterDrawerProps {
  open: boolean;
  onClose: () => void;
  onOpen?: () => void;
  title?: React.ReactNode | string;
  children: React.ReactNode;
}

export const BottomFilterDrawer = ({
  open,
  onClose,
  onOpen,
  title,
  children,
}: BottomFilterDrawerProps) => {
  const handleOpen = onOpen || (() => {});

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={handleOpen}
      disableSwipeToOpen={false}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          maxHeight: '70vh',
          bgcolor: 'background.paper',
        },
      }}
      sx={{
        zIndex: 1300,
      }}
    >
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Drag Handle */}
        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1.5, pb: 2 }}>
          <Box
            sx={{
              width: 40,
              height: 4,
              bgcolor: 'divider',
              borderRadius: 2,
            }}
          />
        </Box>

        {title && (
          <Typography variant="h6" sx={{ px: 2, mb: 2, fontWeight: 700 }}>
            {title}
          </Typography>
        )}

        <Box sx={{ overflowY: 'auto', flex: 1, pb: 4, px: 0 }}>{children}</Box>
      </Box>
    </SwipeableDrawer>
  );
};
